/**
 * сюда в принципе можно переносить все транслейшны - чтобы не
 * плодить объекты по всему приложению и не дублировать одно и то же,
 * но основная моя рекомендация - использовать в функции intl/formatMessage
 * первым параметром ключ (string) перевода, объявленный в файлах из
 * папки i18n/... . Теперь данная возможность реализована и отлично работает.
 * Использовать MessageDescriptor теперь есть смысл только
 * в исключительных случаях, когда необходимы дополнительные параметры типа defaultMessage или description
 */

export default {}
